/**
 * Datas na tela.
 *
 * A regra: data pura é TEXTO `AAAA-MM-DD` do começo ao fim. Nunca vira `Date`
 * do navegador para depois voltar — é aí que o dia 17 vira 16 para quem está
 * num fuso a oeste.
 */

const MESES = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
];

const DIAS_SEMANA = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];

/** `2026-08-17` → `17/08/2026` */
export function paraTela(data: string): string {
  const [ano, mes, dia] = data.split('-');
  return `${dia}/${mes}/${ano}`;
}

/** `2026-08-17` → `segunda, 17 de agosto` */
export function porExtenso(data: string): string {
  const [ano, mes, dia] = data.split('-').map(Number);
  const d = new Date(Date.UTC(ano!, mes! - 1, dia!));
  return `${DIAS_SEMANA[d.getUTCDay()]}, ${dia} de ${MESES[mes! - 1]}`;
}

/** `2026-08` → `agosto de 2026` */
export function nomeDoMes(anoMes: string): string {
  const [ano, mes] = anoMes.split('-').map(Number);
  return `${MESES[mes! - 1]} de ${ano}`;
}

export function somarMeses(anoMes: string, quantos: number): string {
  const [ano, mes] = anoMes.split('-').map(Number);
  const d = new Date(Date.UTC(ano!, mes! - 1 + quantos, 1));
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
}

export function primeiroDia(anoMes: string): string {
  return `${anoMes}-01`;
}

export function ultimoDia(anoMes: string): string {
  const [ano, mes] = anoMes.split('-').map(Number);
  const d = new Date(Date.UTC(ano!, mes!, 0));
  return `${anoMes}-${String(d.getUTCDate()).padStart(2, '0')}`;
}

/**
 * As semanas do mês, para a grade. Cada semana tem 7 posições; as de fora do
 * mês vêm como `null` — a grade mostra célula vazia, não o dia do mês vizinho.
 */
export function semanasDoMes(anoMes: string): Array<Array<string | null>> {
  const [ano, mes] = anoMes.split('-').map(Number);
  const diasNoMes = new Date(Date.UTC(ano!, mes!, 0)).getUTCDate();
  const comecaEm = new Date(Date.UTC(ano!, mes! - 1, 1)).getUTCDay();

  const celulas: Array<string | null> = Array(comecaEm).fill(null);
  for (let dia = 1; dia <= diasNoMes; dia += 1) {
    celulas.push(`${anoMes}-${String(dia).padStart(2, '0')}`);
  }
  while (celulas.length % 7 !== 0) celulas.push(null);

  const semanas: Array<Array<string | null>> = [];
  for (let i = 0; i < celulas.length; i += 7) {
    semanas.push(celulas.slice(i, i + 7));
  }
  return semanas;
}

export const ROTULOS_TIPO: Record<string, string> = {
  entrega: 'Entrega',
  reuniao: 'Reunião',
  interno: 'Interno',
};
